import React from 'react'
import {Short} from './short'

export const Overlay = ({location, connectedLocations, onClose, switchOverlay, switchPopup}) => {
  const links = connectedLocations.sort((a, b) => a.name > b.name ? 1 : -1).map((connectedLocation, i) => {
    return <a key={i} className='overlay-link'
        onMouseEnter={() => switchPopup(connectedLocation.id)}
        onMouseLeave={() => location && switchPopup(location.id)}
        onClick={() => switchOverlay(connectedLocation.id)}>
      <Short location={connectedLocation} />
    </a>
  })

  const isVisible = location || (connectedLocations.length > 0)

  return <div className={`overlay ${isVisible ? 'overlay-visible' : ''}`}>
    <Short location={location} />

    {location && <p>{location.description}</p>}
    {location && <hr />}

    {(connectedLocations.length > 0) && <div>{location && <strong>Verbunden mit:</strong>}{links}</div>}

    <a className='overlay-close' onClick={onClose}>&times;</a>
  </div>
}



// WEBPACK FOOTER //
// ./src/overlay.js